export class JobOwnershipTemplate {
    id!: string
    name!: string
    notes!: string
}
